module Meevo.Components.Interceptors {

    export class DateInterceptor {
        // Convert any date strings in the server response into Date objects
        response(response) {
            var iso8601RegEx = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)Z?$/

            function convertDate(obj) {
                for (var name in obj) {
                    if (typeof obj[name] == 'string' && iso8601RegEx.test(obj[name])) {
                        obj[name] = moment(obj[name]).toDate();
                    } else if (typeof obj[name] == 'object') {
                        convertDate(obj[name]);
                    }
                }
            }

            convertDate(response);
            return response;
        }

        // Convert any date objects to string using moment before a request is made to server to avoid json serializer causing timezone to be applied
        request(config) {
            function convertDate(obj) {
                for (var name in obj) {
                    if (obj[name] instanceof Date) {
                        obj[name] = moment(obj[name]).format();
                    } else if (typeof obj[name] == 'object') {
                        convertDate(obj[name]);
                    }
                }
            }

            if (config.data) {
                var dataClone = jQuery.extend(true, {}, config.data);
                convertDate(dataClone);
                config.data = dataClone;
            }
            
            if (config.params) {
                var paramsClone = jQuery.extend(true, {}, config.params);
                convertDate(paramsClone);
                config.params = paramsClone;
            }
            return config;
        }

        static factory(): Function {
            let svc = () => {
                return new DateInterceptor();
            }

            
            return svc;
        };
    }

    angular.module("meevo.components.interceptors")
        .factory("meevo.components.interceptors.DateInterceptor", DateInterceptor.factory());
}